<template>
  <el-drawer
  :visible.sync="visible"
  :direction="direction"
  :before-close="handleClose"
  :append-to-body="true"
  :title="title"
  size="50%"
  @open="open">
  <div class="drawer__content scrollable only-y">
    <TechnicalSheet :id="technicalSheetId" :puid="puid"/>
  </div>
</el-drawer>
</template>
<script>
import TechnicalSheet from './technical-sheet'

export default {
  name: 'technical-sheet-drawer',
	props: {
    id : {type : Number},
  puid : {type : String, default: null},
    visible : {type : Boolean},
    direction : {
      type : String,
      default : "rtl" //rtl / ltr / ttb / tbb
    }
	},
  data() {
    return {
      technicalSheetId: null,
    };
  },components: {
    TechnicalSheet,
  },
  watch : {
    id: function(val) {
      this.technicalSheetId = val;
    },
  },
	methods: {
    open(){
      this.technicalSheetId = this.id;
    },
    handleClose(){
      this.$emit('close');
    },

	},
	computed: {
    title () {
      return this.$i18n.t('products.details.technicalSheet.technicalSheet');
    },

	},

}
</script>
<style lang="scss" scoped>

.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-40px;
  padding-left:40px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.drawer__content {
  margin-left:20px;
  margin-right:20px;
}

@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}


</style>
